export const draftscolumnHeaders = [
  {
    title: "Title",
    avatar: true,
    filter: "searchTitle",
    width: 296,
  },
  {
    title: "Category",
    filter: "selectCategory",
    dropDown: [
      { name: "Alert", value: 2 },
      { name: "General", value: 1 },
    ],
    width: 133,
  },

  {
    title: "Recipients",
    filter: "searchRecipients",
    width: 189,
  },
  {
    title: "Alert date",
    filter: "datePickerAlert",
    width: 220,
  },
  {
    title: "Status",
    filter: "selectStatus",
    dropDown: [],
    width: 148,
    chip: true,
  },
  {
    title: "Expiry date",
    filter: "datePickerExpiry",
    width: 170,
  },
];

export const scheduleColumnHeaders = [
  {
    title: "Title",
    avatar: true,
    filter: "searchTitle",
    width: 296,
  },
  {
    title: "Category",
    filter: "selectCategory",
    dropDown: [
      { name: "Alert", value: 2 },
      { name: "General", value: 1 },
    ],
    width: 133,
  },
  {
    title: "Recipients",
    filter: "searchRecipients",
    width: 189,
  },

  {
    title: "Alert date",
    filter: "datePickerAlert",
    width: 220,
  },
  {
    title: "Status",
    filter: "selectStatus",
    dropDown: [],
    width: 148,
    chip: true,
  },
  {
    title: "Expiry date",
    filter: "datePickerExpiry",
    width: 170,
  },
];

export const publishedColumnHeaders = [
  {
    title: "Title",
    avatar: true,
    filter: "searchTitle",
    width: 296,
  },
  {
    title: "Category",
    filter: "selectCategory",
    dropDown: [
      { name: "Alert", value: 2 },
      { name: "General", value: 1 },
    ],
    width: 133,
  },
  {
    title: "Recipients",
    filter: "searchRecipients",
    width: 189,
  },
  {
    title: "Published date",
    filter: "datePickerAlert",
    width: 220,
  },
  {
    title: "Status",
    filter: "selectStatusPublished",
    dropDown: ["Published", "Expired"],
    width: 148,
    chip: true,
  },
  {
    title: "Expiry date",
    filter: "datePickerExpiry",
    width: 170,
  },
];
